export default "__VITE_ASSET__1X$bgqpG__"